import api from '../../../config/axios-interceptor';

export const fetchSystemHealth = async () => {
    try {
        return await api.get('/api/v1/observability/health');
    } catch (error) {
        console.error('❌ Error fetching system health:', error);
        throw error;
    }
};
